<template>
  <div class="flex items-center gap-2">
    <span class="whitespace-nowrap text-xs font-semibold text-gray-500">Se não atender:</span>
    <SegmentedControl
      :model-value="modelValue"
      :options="ON_FAIL_OPTIONS"
      ariaLabel="O que fazer se o médico não atender"
      size="sm"
      :test-id="testId"
      @update:model-value="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import SegmentedControl from '@/components/designSystem/SegmentedControl/SegmentedControl.vue'
import type { QualificationOnFail } from '@/types/qualification-eligibility.types'

import { ON_FAIL_OPTIONS } from './policyModel'

withDefaults(defineProps<{ modelValue: QualificationOnFail; testId?: string }>(), {
  testId: 'qualification-on-fail'
})
const emit = defineEmits<{ 'update:modelValue': [value: QualificationOnFail] }>()

// O SegmentedControl só oferece as opções de `ON_FAIL_OPTIONS`.
const onChange = (value: string) => emit('update:modelValue', value as QualificationOnFail)
</script>
